import type { _Guarded } from ":setup/qrouter";
import { flavor$ } from ":src/modules/flavors";

// TODO: check token only once across routes
// TODO: disable token checks on /auth but not /auth/login
// TODO: store non critical indicators in local storage to know this
export const checkFlavors: _Guarded.AGuardStep = {
  runOn: ["app_init", "first_load"],
  loaderMsg: "fetching flavors...",
  errorSkip: true,
  processException(props) {
    console.log("couldn't fetch badge flavors!!!");
    console.error(props.exception);
    return null;
  },
  async checker({ state, base, routeMatchBase, location }) {
    await flavor$.apis.badge.get().catch(async (error) => {
      console.error("error fetching flavor badge :: ", error);
    });
    return null;
  },
};
